import React, { useState, ChangeEvent } from 'react';

type TextBoxesProps = {
  label1?: string;
  placeholder1: string;
  disabled1?: boolean;
  type1: string;
  minDate1?: string;
  maxDate1?: string;
  label2?: string;
  placeholder2: string;
  disabled2?: boolean;
  type2: string;
  minDate2?: string;
  maxDate2?: string;
  value1?: string;
   value2?: string;
  onChange1?: any;
  onChange2?: any;

};

const UrlTextBoxes: React.FC<TextBoxesProps> = ({
  label1,
  placeholder1,
  disabled1 = false,
  type1,
  minDate1,
  maxDate1,
  label2,
  placeholder2,
  disabled2 = false,
  type2,
  minDate2,
  maxDate2,
  value1,
  value2,
  onChange1,
  onChange2
}) => {


  return (
    <div className="flex justify-between space-x-4">
       <div className="flex-3">
      <div className="textbox-container">
        {label1 && <label htmlFor="textbox1">{label1}</label>}
        <input
          id="textbox1"
          type={type1}
          placeholder={placeholder1}
          value={value1}
          onChange={onChange1}
          disabled={disabled1}
          min={minDate1}
          max={maxDate1}
          className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border p-3 text-sm outline-none"
          style={{
            backgroundColor: disabled1 ? '#f3f3f3' : 'white',
            borderColor: disabled1 ? 'none' : '#ccc',
          }}
        /> 
      </div>
      </div>
        <div className="flex-1 flex justify-center items-center">
        {/* Slash */}
        
        <div className="h-12 flex items-center justify-center">
          <span></span>
        </div>
        </div>
        <div className="flex-3">
      <div className="textbox-container">
        {label2 && <label htmlFor="textbox2">{label2}</label>}
       <input
          id="textbox2"
          type={type2}
          placeholder={placeholder2}
          value={value2}
          onChange={onChange2}
          disabled={disabled2}
          min={minDate2}
          max={maxDate2}
          className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border p-3 text-sm outline-none"
          style={{
            backgroundColor: disabled2 ? '#f3f3f3' : 'white',
            borderColor: disabled2 ? 'none' : '#ccc',
          }}
        />
      </div>
      </div>
    </div>
  );
};

export default UrlTextBoxes;
